import axios from 'axios'
import qs from "qs"

axios.defaults.withCredentials = true
const baseURL = process.env.VUE_APP_SERVER_URL

async function httpReq(authRequired, method, url, data, params) {

    if (!(data instanceof FormData)) {
        data = qs.stringify(data);
    }

    let axiosConfig = {
        timeout: method === 'get' ? 15000 : 60000,
        baseURL,
        url,
        method: method,
        data,
        params,
        headers: {},
    }

    if (authRequired) {
        const authToken = localStorage.getItem('authToken')

        if (!authToken) {
            throw Error("Wallet login required")
        }
        axiosConfig['headers']['Auth-Token'] = authToken
    }

    try {
        const res = await axios(axiosConfig)
        return res.data
    }catch (e) {
        console.log(e)
        throw Error(e)
    }
}

export default {
    httpReq
}